<template>
	<div class="new-patient">
		<Breadcrumbs :items="items" />
		<PatientForm />
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PatientForm from "@/components/patient/PatientForm.vue";

export default {
	name: "new-patient",
	components: {
		Breadcrumbs,
		PatientForm
	},
	data: () => ({}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Patients"),
					disabled: false,
					link: true,
					to: { name: "patients" }
				},
				{
					text: this.$gettext("New"),
					disabled: false,
					link: true,
					to: { name: "new-patient" }
				}
			];
		}
	}
};
</script>